import { GeneralApiProblem } from './api';

export type OrderFacility = {
  city?: string;
  countryId?: number;
  stateId?: number;
  isActive?: string; // '1' or '0'
  name?: string;
  nickname?: string;
  postalCode?: string;
  street1?: string;
  street2?: string;
  facilityId?: number;
  type: NewOrExistingFacility;
};

export interface FacilityInformation {
  facilities: OrderFacility[];
  organizationId: number;
  isActive: string;
}

export enum NewOrExistingFacility {
  NEW = 'NEW',
  EXISTING = 'EXISTING',
}

export interface Facility {
  id: number;
  name: string;
  isActive?: number;
  organizationId: number;
  addressId?: number;
  foreignId?: string;
  createdAt: string;
  updatedAt: string;
  timezone: string | null;
  address?: {
    addrId: number;
    street1: string;
    street2: string;
    city: string;
    postalCode: string;
    stateId: number;
    countryId: number;
    stateISO: string;
    state: string;
    countryISO: string;
    country: string;
  };
}

export interface Country {
  id: number;
  iso: string;
  iso3: string;
  name: string;
  printableName: string;
}

export interface State {
  id: number;
  iso: string;
  countryId: number;
  name: string;
  printableName: string;
}

export interface Address {
  city: string;
  street1: string;
  street2: string;
  postalCode: string;
  stateId: number;
  countryId: number;
  createdAt: string;
  updatedAt: string;
}

export interface FullFacility {
  id: number;
  name: string;
  organizationId: number;
  createdAt: string;
  updatedAt: string;
  timezone: string;
  address: Address;
  country: Country;
  state: State;
}

export type GetSomeFacilitiesResult = { kind: 'ok'; data: Facility[] } | GeneralApiProblem;
export type GetAllCountriesResult = { kind: 'ok'; data: Country[] } | GeneralApiProblem;
export type GetAllStatesResult = { kind: 'ok'; data: State[] } | GeneralApiProblem;
